import passwordService from "../../services/password.service"
import router from "../../router";

const state = {
    
};

const mutations = {
    
};

const actions = {
    async forgotPassword({ dispatch, commit }, info) {
      return await passwordService.forgotPassword(info)
          .then(response => {
              if (response.status) {
                  // dispatch("alertSuccess", response.message, { root: true });
                  router.push({path: 'forgot-password-success'})
                  return Promise.resolve(response.data);
              } else {
                  // console.log('forgotPassword module else response')
                  // console.log(response)
                  router.push({path: 'forgot-password-success'})
                  // dispatch("alertError", response.message, { root: true });
                  return Promise.reject(response);
              }
          }).catch(error => {
              // console.log('forgotPassword module catch error ')
              // console.log(error)
              router.push({path: 'forgot-password-success'})
              return Promise.reject(error);
              // dispatch("alertError", error.data.message, { root: true });
          })
          
    },
    async checkKeyInitPassword ({ dispatch, commit }, info) {
        // console.log('checkKeyInitPassword')
        // console.log(info)
        return await passwordService.checkKeyInitPassword(info).then(
            response => {
                if (response.status) {
                    // dispatch("alertSuccess", response.message, { root: true });
                    // console.log("response Module")
                    // console.log(response)
                    return Promise.resolve(response);
                } else {
                    return Promise.resolve(response);
                }
            }
        ).catch(error => {
            return Promise.resolve(error.data);
        })
    },
    async changePasswordForgot({ dispatch, commit }, info) {
        return await passwordService.changePasswordForgot(info).then(
            response => {
                if (response.status) {
                    return Promise.resolve(response);
                } else {
                    return Promise.resolve(response);
                }
            }
        ).catch(error => {
            return Promise.resolve(error.data);
        })
    },
    async changePassword({ dispatch, commit }, info) {
        return await passwordService.changePassword(info).then(
            response => {
                if (response.status) {
                    dispatch("alertSuccess", response.message, { root: true });
                    return Promise.resolve(response);
                } else {
                    dispatch("alertError", response.message, { root: true });
                    return Promise.reject(response);
                }
            }
        ).catch(error => {
            dispatch("alertError", error.data.message, { root: true });
            return Promise.reject(error.data);
        }) 
    },
    
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
